(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8453],{

/***/ 65760:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/poproutes",
      function () {
        return __webpack_require__(13834);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 13834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Poproutes; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2962);
/* harmony import */ var next_useragent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28010);
/* harmony import */ var _providers_RootStoreProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8710);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82913);
/* harmony import */ var _components_MainPage_Cities__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1810);
/* harmony import */ var _components_BreadCrumbs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24277);
/* harmony import */ var _components_Collapsed__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63145);
/* harmony import */ var _providers_SearchStoreProvider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27101);
/* harmony import */ var _utils_serialize__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(27777);











var __N_SSP = true;
function Poproutes(param) {
    var uaString = param.uaString, _store = param.store, user = _store.user, popdirCities = _store.popdirCities, canonicalUrl = param.canonicalUrl;
    var ua = (0,next_useragent__WEBPACK_IMPORTED_MODULE_3__/* .useUserAgent */ .FS)(uaString || window.navigator.userAgent);
    var isMobile = ua.isMobile, isTablet = ua.isTablet;
    var pageRoute = [
        {
            title: "Популярные круизы",
            link: ""
        }
    ];
    var transformData = function(captions, bodies) {
        if (!captions || !bodies) {
            return [];
        }
        return captions === null || captions === void 0 ? void 0 : captions.map(function(caption, index) {
            return {
                title: caption,
                body: (0,_utils_serialize__WEBPACK_IMPORTED_MODULE_10__/* .serialize */ .q)(bodies[index])
            };
        });
    };
    var transformedData = transformData(popdirCities.seo_text_caption, popdirCities.seo_text);
    console.log(popdirCities, "popdirCities");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_providers_SearchStoreProvider__WEBPACK_IMPORTED_MODULE_9__/* .SearchStoreProvider */ .YG, {
        hydrationData: {
            user: user
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_providers_RootStoreProvider__WEBPACK_IMPORTED_MODULE_4__/* .RootStoreProvider */ .LD, {
            hydrationData: {
                user: user
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .NextSeo */ .PB, {
                    title: popdirCities.seoTitle,
                    description: popdirCities.seo_description,
                    additionalLinkTags: [
                        {
                            rel: "shortcut icon",
                            href: "/favicon.ico?v=2"
                        }, 
                    ],
                    canonical: canonicalUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_5__/* .Layout */ .A, {
                    isMobile: isMobile,
                    isTablet: isTablet,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "container--block",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BreadCrumbs__WEBPACK_IMPORTED_MODULE_7__/* .BreadCrumbs */ .b, {
                                    routeCrumbs: pageRoute
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MainPage_Cities__WEBPACK_IMPORTED_MODULE_6__/* .Cities */ .S, {
                                items: popdirCities.data,
                                isMobile: isMobile,
                                title: popdirCities.title,
                                isRoutes: true
                            }),
                            popdirCities.seo_text_caption && popdirCities.seo_text && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                style: {
                                    marginTop: 24
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Collapsed__WEBPACK_IMPORTED_MODULE_8__/* .Collapsed */ .H, {
                                            items: transformedData,
                                            isCruis: true
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 27777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ serialize; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var slate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77493);
/* harmony import */ var escape_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95573);
/* harmony import */ var escape_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(escape_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Image_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49028);





var serialize = function(children) {
    return children === null || children === void 0 ? void 0 : children.map(function(node, i) {
        if (node.type === "numbered-list") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                children: serialize(node.children)
            }, i);
        }
        if (slate__WEBPACK_IMPORTED_MODULE_4__/* .Text.isText */ .xv.isText(node)) {
            var text = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                dangerouslySetInnerHTML: {
                    __html: escape_html__WEBPACK_IMPORTED_MODULE_2___default()(node.text)
                }
            });
            if (node.bold) {
                text = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                    children: text
                }, i);
            }
            if (node.code) {
                text = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("code", {
                    children: text
                }, i);
            }
            if (node.italic) {
                text = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                    children: text
                }, i);
            }
            if (node.underline) {
                text = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    style: {
                        textDecoration: "underline"
                    },
                    children: text
                }, i);
            }
            if (node.strikethrough) {
                text = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    style: {
                        textDecoration: "line-through"
                    },
                    children: text
                }, i);
            }
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: text
            }, i);
        }
        if (!node) {
            return null;
        }
        switch(node.type){
            case "h1":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    children: serialize(node.children)
                }, i);
            case "h2":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    children: serialize(node.children)
                }, i);
            case "h3":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    children: serialize(node.children)
                }, i);
            case "h4":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                    children: serialize(node.children)
                }, i);
            case "h5":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                    children: serialize(node.children)
                }, i);
            case "h6":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                    children: serialize(node.children)
                }, i);
            case "blockquote":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("blockquote", {
                    children: serialize(node.children)
                }, i);
            case "ul":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    children: serialize(node.children)
                }, i);
            case "ol":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                    children: serialize(node.children)
                }, i);
            case "li":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    children: serialize(node.children)
                }, i);
            case "list-item":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    children: serialize(node.children)
                }, i);
            case "heading-one":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    children: serialize(node.children)
                }, i);
            case "heading-two":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    children: serialize(node.children)
                }, i);
            case "link":
                if (node.url.includes("youtube.com") || node.url.includes("https://vk.com/video")) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            height: "420px"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                            width: "100%",
                            title: "YouTube video player",
                            src: node.url,
                            allowFullScreen: true,
                            allow: "accelerometer",
                            referrerPolicy: "strict-origin-when-cross-origin"
                        })
                    });
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    href: escape_html__WEBPACK_IMPORTED_MODULE_2___default()(node.url),
                    rel: "noopener noreferrer",
                    style: {
                        color: "blue"
                    },
                    children: serialize(node.children)
                }, i);
            case "image":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Image_Image__WEBPACK_IMPORTED_MODULE_3__/* .Image */ .E, {
                    src: escape_html__WEBPACK_IMPORTED_MODULE_2___default()(node.url),
                    srcSet: escape_html__WEBPACK_IMPORTED_MODULE_2___default()(node.url),
                    alt: escape_html__WEBPACK_IMPORTED_MODULE_2___default()(node.alt),
                    title: escape_html__WEBPACK_IMPORTED_MODULE_2___default()(node.title),
                    loading: "lazy",
                    itemProp: "image"
                });
            default:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: serialize(node.children)
                }, i);
        }
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1272,718,3108,7499,4734,9774,2888,179], function() { return __webpack_exec__(65760); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);